import { Injectable } from '@angular/core';

import  IntroJs  from 'intro.js';

@Injectable({
  providedIn: 'root'
})
export class IntrojsService {
  introJS:any = null;
  constructor() { }

  welcome(appMain:any) {
    if (localStorage.getItem("welcome-done")=="true"){
      return;
    }
    this.introJS = IntroJs();
    //this.introJS.start();
    this.introJS.setOptions(
      {
        steps: [
          {
            element: '#main-menu-icon',
            title:"Main menu icon",
            intro:
              "Use to open the left hand side menu and togle the it''s visibility."
          },{
            element: '#top-menu-uioptions',
            title:"UI Settings",
            intro:
              "Use this menu to change the appearace of UI, theme and font size"
          },
          {
            element: '#top-menu-user',
            title:"User Profile",
            intro:
              "Your user profile information and log out"
          },{
            element: '#top-menu-help',
            title:"Help",
            intro:
              "Launch the help and quick start up wizard"
          },
        ]
      }
    ).onbeforeexit(function () {
      appMain.helpActive = true;
      appMain.helpClick = true;
      localStorage.setItem("welcome-done","true");
      //return confirm("Are you sure?");
    }).start();

  }
}
